import React, { useContext, useEffect, useState } from 'react';
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { ThemeContext } from '../../context/theme.context';
import BusinessLogiConfiguration from './BusinessLogiConfiguration';
import SourceAdaptor from './SourceAdaptor';
import SyncContainer from './SyncContainer';
import TaskManager from './TaskManager';
import TaskTracker from './TaskTracker';

const DigTabHub: React.FC = () => {
  const context = useContext(ThemeContext);
  const [currentTab, setCurrentTab] = useState(0);
  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    if (context.isChangeCurrentTab) {
      setCurrentTab(1);
      context.setChangeCurrentTab(
        false,
        context.changeCurrentContainerTabIndex
      );
    }
    if (context.isChangeCurrentTabTask) {
      setCurrentTab(2);
      context.setChangeCurrentTabTask(false, context.currentTabTaskIndex);
    }
  }, [context]);

  useEffect(() => {
    const handleOrgChange = () => {
      const { pathname, hash } = window.location;
      const fullPath = (pathname + hash).toLowerCase();
      const isDigModule = /(^|\/|#)dig(\/|\?|#|$)/i.test(fullPath);
      if (isDigModule) {
        setRenderKey(prev => prev + 1);
      }
    };

    window.addEventListener('organizationChanged', handleOrgChange);
    return () => {
      window.removeEventListener('organizationChanged', handleOrgChange);
    };
  }, []);

  return (
    <div key={renderKey}>
      <TabComponent
        key={`dig-tab-${renderKey}`}
        selectedItem={currentTab}
        heightAdjustMode='Auto'
        selected={(args: any) => {
          setCurrentTab(args.selectingIndex);
        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={{
              text: 'Source Adapter',
            }}
            content={() => <SourceAdaptor key={`sa-${renderKey}`} />}
          />
          <TabItemDirective
            header={{
              text: 'Sync Container',
            }}
            content={() => <SyncContainer key={`sc-${renderKey}`} />}
          />
          <TabItemDirective
            header={{
              text: 'Task Manager',
            }}
            content={() => <TaskManager key={`tm-${renderKey}`} />}
          />
          <TabItemDirective
            header={{
              text: 'Business Logic Configuration',
            }}
            content={() => <BusinessLogiConfiguration key={`blc-${renderKey}`} />}
          />
          <TabItemDirective
            header={{
              text: 'Task Tracker',
            }}
            content={() => <TaskTracker key={`tt-${renderKey}`} />}
          />
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
};

export default DigTabHub;
